import { carouselItems } from '@/mocks/homeData';

const carouselImages = [
  "https://readdy.ai/api/search-image?query=Summer%20blockbuster%20movie%20collage%20with%20explosive%20action%20scenes%2C%20vibrant%20warm%20colors%2C%20cinematic%20lighting%2C%20film%20poster%20style%2C%20golden%20and%20crimson%20highlights%2C%20dramatic%20composition%2C%20no%20text%2C%20professional%20movie%20marketing%20aesthetic&width=800&height=450&seq=jiubo-carousel-01&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Mystery%20thriller%20film%20aesthetic%20with%20dark%20atmosphere%2C%20dramatic%20shadows%2C%20warm%20amber%20lighting%2C%20suspenseful%20cinematic%20mood%2C%20film%20noir%20style%2C%20rich%20contrast%2C%20no%20text%2C%20professional%20cinematography&width=800&height=450&seq=jiubo-carousel-02&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Chinese%20animation%20film%20art%20with%20oriental%20aesthetic%2C%20ink%20wash%20painting%20style%2C%20warm%20earthy%20tones%2C%20traditional%20Chinese%20art%20elements%2C%20soft%20golden%20light%2C%20cinematic%20composition%2C%20no%20text%2C%20elegant%20visual%20design&width=800&height=450&seq=jiubo-carousel-03&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Classic%20Hong%20Kong%20cinema%20nostalgia%20with%20retro%20film%20texture%2C%20warm%20vintage%20tones%2C%20old%20movie%20theater%20atmosphere%2C%20nostalgic%20lighting%2C%20film%20grain%2C%20golden%20hour%20glow%2C%20no%20text%2C%20professional%20photography&width=800&height=450&seq=jiubo-carousel-04&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Prestigious%20film%20awards%20ceremony%20aesthetic%20with%20golden%20trophy%20and%20red%20carpet%20elements%2C%20luxurious%20warm%20lighting%2C%20elegant%20cinematic%20atmosphere%2C%20rich%20gold%20and%20burgundy%20tones%2C%20no%20text%2C%20professional%20photography&width=800&height=450&seq=jiubo-carousel-05&orientation=landscape",
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-2">
            精选推荐
          </h2>
          <p className="text-sm text-foreground-600">
            精心策划的五大专题，发现你的下一部最爱
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 md:gap-4">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className="group cursor-pointer bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-accent-200/50 transition-all duration-300 flex flex-col"
            >
              <div className="relative aspect-[16/9] overflow-hidden bg-background-200">
                <img
                  src={carouselImages[i]}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/50 to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3">
                  <span className="text-xs text-background-100 font-medium bg-primary-500/90 px-2 py-0.5 rounded-full">
                    {item.subtitle}
                  </span>
                </div>
              </div>
              <div className="p-3 md:p-4 flex-1 flex flex-col">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-3 flex-1">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}